import { Schema as S } from "effect";
import { defineMessageUnion } from "foldkit/message";

import {
	createNote,
	listFolders,
	listNotes,
	moveNote,
	renameFolder,
	searchNotes,
} from "../../api/commands/notes";

export const Message = defineMessageUnion({
	/** `now` is read from Clock beside the fetch, so "updated 2 hr ago" stays pure. */
	CompletedFetchNotes: {
		generation: S.Number,
		/** The folder fetched (null = all); a result for another folder is dropped. */
		folder: S.NullOr(S.String),
		now: S.Number,
		result: listNotes.Result,
	},
	CompletedFetchFolders: { generation: S.Number, result: listFolders.Result },
	ChangedTag: { tag: S.NullOr(S.String) },
	ChangedQuery: { value: S.String },
	/** The debounce timer for `query` ran out; ignored if the text moved on. */
	SearchDebounced: { query: S.String },
	ToggledIncludeRecords: {},
	CompletedSearch: {
		q: S.String,
		includeRecords: S.Boolean,
		generation: S.Number,
		result: searchNotes.Result,
	},
	ClickedNewNote: {},
	CompletedCreate: { generation: S.Number, result: createNote.Result },
	CompletedNavigate: {},
	ToggledFolder: { path: S.String },
	ClickedNewFolder: {},
	ClickedRenameFolder: {},
	ChangedFolderName: { value: S.String },
	SubmittedFolderForm: {},
	CancelledFolderForm: {},
	CompletedFocusFolderName: {},
	/** Opens or closes a note's Move menu (the keyboard path for drag-and-drop). */
	ClickedMove: { id: S.String },
	ChoseFolder: { id: S.String, folder: S.String },
	StartedDrag: { id: S.String },
	EndedDrag: {},
	EnteredFolder: { folder: S.String },
	LeftFolder: { folder: S.String },
	DroppedOnFolder: { folder: S.String },
	CompletedMove: {
		generation: S.Number,
		folder: S.String,
		result: moveNote.Result,
	},
	CompletedRename: {
		generation: S.Number,
		from: S.String,
		to: S.String,
		result: renameFolder.Result,
	},
});
export type Message = typeof Message.Type;
